import React from "react";
import Select, { components } from "react-select";
import { Icon } from "@iconify/react/dist/iconify.js";

// Shared combobox multi-select for every "pick more than one item" scenario
// (teachers, students, subjects, taxes, ...). Selecting an option checks it
// green right inside the open dropdown (closeMenuOnSelect: false,
// hideSelectedOptions: false) instead of only showing removable chips —
// matches the "seleccionas na própria combobox e ele assinala a verde" UX.
export const multiSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    background: "var(--neutral-50)",
    borderRadius: 8,
    borderColor: state.isFocused ? "var(--primary-600)" : "var(--neutral-300)",
    boxShadow: state.isFocused ? "0 0 0 1px var(--primary-600)" : "none",
    "&:hover": { borderColor: "var(--primary-600)" },
  }),
  valueContainer: (base) => ({ ...base, padding: "2px 8px" }),
  placeholder: (base) => ({ ...base, color: "var(--text-secondary-light)" }),
  input: (base) => ({ ...base, color: "var(--neutral-900)" }),
  multiValue: (base) => ({ ...base, background: "var(--success-focus)", borderRadius: 6 }),
  multiValueLabel: (base) => ({ ...base, color: "var(--success-main)" }),
  menu: (base) => ({
    ...base,
    background: "var(--neutral-50)",
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 12px 24px rgba(0,0,0,0.12)",
    zIndex: 20,
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: state.isFocused ? "rgba(72,127,255,0.1)" : "transparent",
    color: "var(--neutral-900)",
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "var(--text-secondary-light)" }),
};

const CheckboxOption = (props) => (
  <components.Option {...props}>
    <span
      className='d-inline-flex align-items-center justify-content-center rounded-1'
      style={{
        width: 18,
        height: 18,
        border: props.isSelected ? "none" : "1.5px solid var(--neutral-300)",
        background: props.isSelected ? "var(--success-main)" : "transparent",
        flexShrink: 0,
      }}
    >
      {props.isSelected && <Icon icon='mdi:check-bold' style={{ fontSize: 12, color: "#fff" }} />}
    </span>
    <span>{props.label}</span>
  </components.Option>
);

// items: raw objects. getOptionValue/getOptionLabel: how to derive {value,label}.
// selectedIds: array of raw id values (keeps caller state as plain ids, not react-select shape).
const MultiSelectField = ({
  items = [],
  getOptionValue = (item) => item.id,
  getOptionLabel = (item) => item.name,
  selectedIds = [],
  onChange,
  placeholder,
  isLoading,
  noOptionsMessage,
}) => {
  const options = items.map((item) => ({ value: getOptionValue(item), label: getOptionLabel(item) }));
  const value = options.filter((o) => selectedIds.includes(o.value));

  return (
    <Select
      isMulti
      options={options}
      value={value}
      onChange={(selected) => onChange((selected || []).map((o) => o.value))}
      placeholder={placeholder}
      isLoading={isLoading}
      styles={multiSelectStyles}
      classNamePrefix='rs'
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      components={{ Option: CheckboxOption }}
      noOptionsMessage={() => noOptionsMessage || "—"}
    />
  );
};

export default MultiSelectField;
